import { render, staticRenderFns } from "./RecipientEmailEditor.vue?vue&type=template&id=3f356e6a&scoped=true&"
import script from "./RecipientEmailEditor.vue?vue&type=script&lang=js&"
export * from "./RecipientEmailEditor.vue?vue&type=script&lang=js&"
import style0 from "./RecipientEmailEditor.vue?vue&type=style&index=0&id=3f356e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f356e6a",
  null
  
)

export default component.exports